(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rd26_geometry-chart"] && !Shopify.designMode) return;
  try {
    function toggleHighlight(element, trueOrFalse) {
    const currentRow = returnCurRow(element);
    const index = element.currentTarget.cellIndex;
    const table = document.getElementById('hoverTable').rows;

    // Highlight matching column header
    const headerRow = table[0];

    if (headerRow) {
      const headerCells = headerRow.querySelectorAll('.rd26-geometry-chart__size-header');

      headerCells.forEach((header) => {
        if (header.cellIndex === index) {
          trueOrFalse ? header.classList.add('hoverHighlight') : header.classList.remove('hoverHighlight');
        }
      });
    }

    for (let i = 0; i < table.length; i++) {
      const row = table[i];

      const cells = row.querySelectorAll('.cell');
      const rowLabel = row.querySelector('.rd26-geometry-chart__label');

      // Highlight active row
      if (row.rowIndex === currentRow) {
        cells.forEach((td) => {
          trueOrFalse ? td.classList.add('hoverHighlight') : td.classList.remove('hoverHighlight');
        });

        if (rowLabel) {
          trueOrFalse ? rowLabel.classList.add('hoverHighlight') : rowLabel.classList.remove('hoverHighlight');
        }
      }

      // Highlight active column
      cells.forEach((cell) => {
        if (cell.cellIndex === index) {
          trueOrFalse ? cell.classList.add('hoverHighlight') : cell.classList.remove('hoverHighlight');
        }
      });
    }
  }

  function addHoverEventsAndClasses() {
    const mainTableTDs = document.querySelectorAll('#hoverTable td');
    const mainTableTRs = document.querySelectorAll('#hoverTable tr');
    //Dynamically add class names to each row and cell to target
    addClass(mainTableTRs, 'row');
    addClass(mainTableTDs, 'cell');
    mainTableTDs.forEach((td) => {
      td.addEventListener('mouseenter', highlightCol);
      td.addEventListener('mouseleave', removeHighlightCol);
    });
  }
  //Helper function for adding highlight classes
  function addClass(el, cl) {
    el.forEach((child) => {
      child.classList.add(cl);
    });
  }
  function highlightCol(e) {
    toggleHighlight(e, true);

    e.currentTarget.classList.add('hoverHighlight--active');
  }

  function removeHighlightCol(e) {
    toggleHighlight(e, false);

    e.currentTarget.classList.remove('hoverHighlight--active');
  }
  //Grab the current row
  const returnCurRow = (e) => {
    return e.currentTarget.parentElement.rowIndex;
  };

  function initializeGeometryToggle() {
    const tableWrap = document.querySelector('[data-rd26-geometry-scroller]');

    const toggleButton = document.querySelector('[data-rd26-geometry-toggle]');

    if (!tableWrap || !toggleButton) return;

    const rows = tableWrap.querySelectorAll('tbody tr');

    // Hide toggle if table is already short
    if (rows.length <= 10) {
      toggleButton.style.display = 'none';
      return;
    }

    // Default collapsed state
    tableWrap.classList.add('is-collapsed');

    toggleButton.addEventListener('click', () => {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

      tableWrap.classList.toggle('is-collapsed');

      toggleButton.setAttribute('aria-expanded', String(!isExpanded));

      toggleButton.textContent = isExpanded ? 'Show Full Geometry' : 'Show Less';
    });
  }

  window.addEventListener('load', function () {
    addHoverEventsAndClasses();
    initializeGeometryToggle();
  });
  } catch(e) { console.error(e); }
})();

})();
